import { render, staticRenderFns } from "./situazione.vue?vue&type=template&id=2b76c23f&scoped=true&lang=html"
import script from "./situazione.vue?vue&type=script&lang=js"
export * from "./situazione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b76c23f",
  null
  
)

export default component.exports